module.exports = __webpack_public_path__ + "fonts/Gilroy-Medium.7d5dc179.woff";